const DEFAULT_SIZES = ['35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'Único'];

export function getPersistedSizes(): string[] {
  const stored = localStorage.getItem('aye_calzados_sizes');
  if (stored) {
    try {
      return JSON.parse(stored) as string[];
    } catch {
      return DEFAULT_SIZES;
    }
  }
  // Initialize on first access
  localStorage.setItem('aye_calzados_sizes', JSON.stringify(DEFAULT_SIZES));
  return DEFAULT_SIZES;
}

export function savePersistedSizes(sizes: string[]): void {
  localStorage.setItem('aye_calzados_sizes', JSON.stringify(sizes));
}
